<template>
  <div>
    <div style="width: 100%; height: 100%;" v-if="this.$store.state.device.isMobile">
      <navbarTop></navbarTop>
      <navbarBottom></navbarBottom>
      <div style="padding: 80px 16px 120px;margin: auto;">
        <p style="color: #2B2D42;margin: 0;" align="left">{{ $t('pages.CSV.text1') }}</p>
        <p style="color: #2B2D42;" align="left">{{ $t('pages.CSV.text2') }}</p>

        <b-row style="margin-bottom: 5%;">
          <b-col style="width: 40%;">
            <img src="../../public/img/filter.svg" style="position: absolute; right: 30px; top: 8px; color: #2B2D42; z-index: 900;" class="fas fa-search">
            <b-form-select class="btnFilter" v-model="status" :options="status_options"></b-form-select>
          </b-col>
          <b-col style="width: 40%;">
            <img src="../../public/img/filter.svg" style="position: absolute; right: 30px; top: 8px; color: #2B2D42; z-index: 900;" class="fas fa-search">
            <b-form-select class="btnFilter" v-model="active" :options="active_options"></b-form-select>
          </b-col>
        </b-row>

        <b-row class="check_row_border">
          <b-col align="center">
            <label class="container">
              <input  type="checkbox"
                      v-model="checkAll"
                      value="1"
                      unchecked-value="0"
                      v-on:change="toggleAll">
              <span class="checkmark"></span>
            </label>
          </b-col>
          <b-col align="left">
            <p>{{ $t('pages.CSV.options_all') }}</p>
          </b-col>
        </b-row>

        <b-row class="check_row_border" v-for="opt in options" :key="opt.text">
          <b-col align="center">
            <label class="container">
              <input  type="checkbox"
                      v-model="opt.value"
                      :value="opt.value"
                      unchecked-value=""
                      v-on:change="checkToggleAll">
              <span class="checkmark"></span>
            </label>
          </b-col>
          <b-col align="left">
            <p>{{opt.text}}</p>
          </b-col>
        </b-row>

        <b-button id="btnDownload" v-on:click="download">
          Download
          <img src="../../public/img/download.svg" style="padding-bottom: 5px" class="fas fa-arrow-circle-right">
        </b-button>

      </div>
    </div>

    <div v-if="this.$store.state.device.isDesktop">
      <navbarTop></navbarTop>
      <sideBar></sideBar>
      <div class="desktop_container">
        <h5><b>Download</b></h5>
        <hr style="background-color: #8D99AE; border: 1px solid #8D99AE">
        <p style="color: #2B2D42;margin: 0;" align="left">{{ $t('pages.CSV.text1') }}</p>
        <p style="color: #2B2D42;" align="left">{{ $t('pages.CSV.text2') }}</p>

        <b-row style="margin-bottom: 25px;">
          <b-col :cols="width > 1200 ? 3 : 6">
            <img src="../../public/img/filter.svg" style="position: absolute; right: 30px; top: 8px; color: #2B2D42; z-index: 900;" class="fas fa-search">
            <b-form-select class="btnFilter_desktop" v-model="status" :options="status_options"></b-form-select>
          </b-col>
          <b-col :cols="width > 1200 ? 3 : 6">
            <img src="../../public/img/filter.svg" style="position: absolute; right: 30px; top: 8px; color: #2B2D42; z-index: 900;" class="fas fa-search">
            <b-form-select class="btnFilter_desktop" v-model="active" :options="active_options"></b-form-select>
          </b-col>
        </b-row>

        <b-row class="check_row_border_desktop">
          <b-col cols="2" style="padding-left: 0;">
            <label class="container">
              <input  type="checkbox"
                      v-model="checkAll"
                      value="1"
                      unchecked-value="0"
                      v-on:change="toggleAll">
              <span class="checkmark_desktop"></span>
            </label>
          </b-col>
          <b-col cols="10">
            <p>{{ $t('pages.CSV.options_all') }}</p>
          </b-col>
        </b-row>
         
        <b-row class="check_row_border_desktop" v-for="opt in options" :key="opt.text">
          <b-col cols="2" style="padding-left: 0;">
            <label class="container">
              <input  type="checkbox"
                      v-model="opt.value"
                      :value="opt.value"
                      unchecked-value=""
                      v-on:change="checkToggleAll">
              <span class="checkmark_desktop"></span>
            </label>
          </b-col>
          <b-col cols="10">
            <p>{{opt.text}}</p>
          </b-col>
        </b-row>

        <b-button id="btnDownload" v-on:click="download">
          Download
          <img src="../../public/img/download.svg" style="padding-bottom: 5px" class="fas fa-arrow-circle-right">
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
  import NavbarTop from "../components/navbarTop";
  import navbarBottom from "../components/navbarBottom";
  import sideBar from "../components/sideBar";
  import {MembersCSV} from "../api/Member/apiMember";
  import BCheckbox from "buefy/src/components/checkbox/Checkbox";
  const pt = require('../translations/pt-PT/pt-PT');
  const en = require('../translations/en-GB/en-GB');
  export default {
    name: "csv",
    data() {
      return {
        options: [],
        options_backup: [ { value: 'number' },
                          { value: 'name' },
                          { value: 'birthday_date' },
                          { value: 'phone_number' },
                          { value: 'address' },
                          { value: 'email' },
                          { value: 'created' },
                          { value: 'notes' } ],
        status: null,
        active: null,
        status_options: [],
        active_options: [],
        width: null,
        checkAll: 1
      };
    },
    components: {BCheckbox, NavbarTop, navbarBottom, sideBar},
    methods: {
      toggleAll: function () {
        let checkFalseOptions = null;
        this.options.forEach(obj => {
          if(obj.value == false) checkFalseOptions = true;
        })
        if(!checkFalseOptions){
           if(localStorage.getItem('language')=='pt') {
            this.options = [
              { text: pt.pages.CSV.options_number, value: false },
              { text: pt.pages.CSV.options_name, value: false },
              { text: pt.pages.CSV.options_birthday_date, value: false },
              { text: pt.pages.CSV.options_phone_number, value: false },
              { text: pt.pages.CSV.options_address, value: false },
              { text: pt.pages.CSV.options_email, value: false },
              { text: pt.pages.CSV.options_created, value: false },
              { text: pt.pages.CSV.options_notes, value: false }
            ]
          }
          if(localStorage.getItem('language')=='en') {
            this.options = [
              { text: en.pages.CSV.options_number, value: false },
              { text: en.pages.CSV.options_name, value: false },
              { text: en.pages.CSV.options_birthday_date, value: false },
              { text: en.pages.CSV.options_phone_number, value: false },
              { text: en.pages.CSV.options_address, value: false },
              { text: en.pages.CSV.options_email, value: false },
              { text: en.pages.CSV.options_created, value: false },
              { text: en.pages.CSV.options_notes, value: false }
            ]
          }
        } else {
          if(localStorage.getItem('language')=='pt') {
            this.options = [
              { text: pt.pages.CSV.options_number, value: 'number' },
              { text: pt.pages.CSV.options_name, value: 'name' },
              { text: pt.pages.CSV.options_birthday_date, value: 'birthday_date' },
              { text: pt.pages.CSV.options_phone_number, value: 'phone_number' },
              { text: pt.pages.CSV.options_address, value: 'address' },
              { text: pt.pages.CSV.options_email, value: 'email' },
              { text: pt.pages.CSV.options_created, value: 'created' },
              { text: pt.pages.CSV.options_notes, value: 'notes' }
            ]
          }
          if(localStorage.getItem('language')=='en') {
            this.options = [
              { text: en.pages.CSV.options_number, value: 'number' },
              { text: en.pages.CSV.options_name, value: 'name' },
              { text: en.pages.CSV.options_birthday_date, value: 'birthday_date' },
              { text: en.pages.CSV.options_phone_number, value: 'phone_number' },
              { text: en.pages.CSV.options_address, value: 'address' },
              { text: en.pages.CSV.options_email, value: 'email' },
              { text: en.pages.CSV.options_created, value: 'created' },
              { text: en.pages.CSV.options_notes, value: 'notes' }
            ]
          }
        } 
      },
      checkToggleAll: function() {
        let isThereFalseOpt = null;
        this.options.forEach(opt => {
          if(opt.value == false) isThereFalseOpt = true;
        })
        if(isThereFalseOpt) this.checkAll = 0;
        else this.checkAll = 1;
      },
      download: function () {
        let spinner = this.$loading.open();
        let data = {};
        data.cols = [];
        this.options.forEach((opt,i) => {
          if(opt.value == true) {data.cols.push(this.options_backup[i].value);}
          else if((opt.value != "") || (opt.value != false)) {data.cols.push(this.options_backup[i].value);}
        });
        if(this.status != null) data.status=this.status;
        if(this.active != null) data.active=this.active;
        
        MembersCSV(data)
                .then((response) => {
                  let fileURL = window.URL.createObjectURL(new Blob(["\ufeff",response.data], {type: "text/csv;charset=utf-8"}));
                  let fileLink = document.createElement('a');
                  fileLink.href = fileURL;
                  let date = new Date();
                  let month = date.getMonth() + 1;
                  fileLink.setAttribute('download', 'socios-' + month + '-' + date.getFullYear() + '.csv');
                  document.body.appendChild(fileLink);
                  fileLink.click();
                  spinner.close();
                })
                .catch(error => {
                spinner.close();
                  if (!error.response) this.$toast.open({message: "O servidor não está a responder...", type: 'is-danger'});
                  else{
                    let response_error = error.response.data;
                    this.$toast.open({message: response_error[Object.keys(response_error)[0]].msg.code, type: 'is-danger'});
                  }
                });
                
      }
    },
    mounted() {
      let spinner = this.$loading.open();

      this.width = Math.max(self.innerWidth || 0, document.documentElement.clientWidth || 0, document.body.clientWidth || 0);
      //==============================OPTIONS
      if(localStorage.getItem('language')=='pt') {
        this.options = [
          { text: pt.pages.CSV.options_number, value: 'number' },
          { text: pt.pages.CSV.options_name, value: 'name' },
          { text: pt.pages.CSV.options_birthday_date, value: 'birthday_date' },
          { text: pt.pages.CSV.options_phone_number, value: 'phone_number' },
          { text: pt.pages.CSV.options_address, value: 'address' },
          { text: pt.pages.CSV.options_email, value: 'email' },
          { text: pt.pages.CSV.options_created, value: 'created' },
          { text: pt.pages.CSV.options_notes, value: 'notes' }
        ]
      }
      if(localStorage.getItem('language')=='en') {
        this.options = [
          { text: en.pages.CSV.options_number, value: 'number' },
          { text: en.pages.CSV.options_name, value: 'name' },
          { text: en.pages.CSV.options_birthday_date, value: 'birthday_date' },
          { text: en.pages.CSV.options_phone_number, value: 'phone_number' },
          { text: en.pages.CSV.options_address, value: 'address' },
          { text: en.pages.CSV.options_email, value: 'email' },
          { text: en.pages.CSV.options_created, value: 'created' },
          { text: en.pages.CSV.options_notes, value: 'notes' }
        ]
      }

      //==============================STATUS OPTIONS
      if(localStorage.getItem('language')=='pt') {
        this.status_options = [
          { value: null, text: pt.pages.CSV.options_status_fees },
          { value: '1', text: pt.pages.CSV.options_status_fees_ok },
          { value: '2', text: pt.pages.CSV.options_status_fees_delay }
        ]
      }
      if(localStorage.getItem('language')=='en') {
        this.status_options = [
          { value: null, text: en.pages.CSV.options_status_fees },
          { value: '1', text: en.pages.CSV.options_status_fees_ok },
          { value: '2', text: en.pages.CSV.options_status_fees_delay }
        ]
      }

      //==============================ACTIVE OPTIONS
      if(localStorage.getItem('language')=='pt') {
        this.active_options = [
          { value: null, text: pt.pages.CSV.options_active_member },
          { value: '0', text: pt.pages.CSV.options_active_member_not_Active },
          { value: '1', text: pt.pages.CSV.options_active_member_active }
        ]
      }
      if(localStorage.getItem('language')=='en') {
        this.active_options = [
          { value: null, text: en.pages.CSV.options_active_member },
          { value: '0', text: en.pages.CSV.options_active_member_not_Active },
          { value: '1', text: en.pages.CSV.options_active_member_active }
        ]
      }

      spinner.close();
    }
  };
</script>

<style scoped>
  .desktop_container {
    text-align: left !important;
    margin-bottom: 100px !important;
  }
  .check_row_border {
    border-bottom: 1px solid #8D99AE;
    width: 100%;
    margin: auto;
    padding-top: 5%;
  }
  @media (max-width: 1200px) {
    .check_row_border_desktop {
      border-bottom: 1px solid #8D99AE;
      width: 50%;
      padding-top: 30px;
      padding-bottom: 10px;
      margin-left: 2px;
    }
  }
  @media (min-width: 1200px) {
    .check_row_border_desktop {
      border-bottom: 1px solid #8D99AE;
      width: 25%;
      padding-top: 30px;
      padding-bottom: 10px;
      margin-left: 2px;
    }
  }
  @media (max-width: 330px) {
    #btnDownload {
      background: #2B2D42 0% 0% no-repeat padding-box;
      border-radius: 32px;
      color: white;
      border: none;
      letter-spacing: 0.85px;
      position: fixed;
      bottom: 70px;
      right: 10px;
      padding: 10px;
    }
  }
  @media (min-width: 330px) and (max-width: 750px){
    #btnDownload {
      background: #2B2D42 0% 0% no-repeat padding-box;
      border-radius: 32px;
      color: white;
      border: none;
      letter-spacing: 0.85px;
      position: fixed;
      bottom: 70px;
      right: 10px;
      font-size: 125%;
      padding: 14px;
    }
  }
  @media (min-width: 750px) and (max-width: 1200px) {
    #btnDownload {
      background: #2B2D42 0% 0% no-repeat padding-box;
      border-radius: 32px;
      color: white;
      border: none;
      letter-spacing: 0.85px;
      position: fixed;
      bottom: 20px;
      right: 20px;
      font-size: 125%;
      padding: 16px;
    }
  }
  @media (min-width: 1200px) {
    #btnDownload {
      background: #2B2D42 0% 0% no-repeat padding-box;
      border-radius: 32px;
      color: white;
      border: none;
      letter-spacing: 0.85px;
      position: fixed;
      bottom: 20px;
      right: 20px;
      font-size: 125%;
      padding: 16px;
    }
  }
  .btnFilter {
    height: 100%;
    width: 100%;
    background: #2B2D42 0% 0% no-repeat padding-box;
    border-radius: 32px;
    color: white;
    border: none;
    letter-spacing: 0.85px;
  }
  .btnFilter_desktop {
    height: 100%;
    width: 100%;
    background: #2B2D42 0% 0% no-repeat padding-box;
    border-radius: 32px;
    color: white;
    border: none;
    letter-spacing: 0.85px;
    padding-left: 20px;
  }

  .container {
    display: block;
    position: relative;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 3vh;
    width: 3vh;
    background-color: #ffffff;
    border: 2px solid #2B2D42;
    border-radius: 32px;
    margin-left: 40%;
    margin-top: 1%;
  }

  .checkmark_desktop {
    position: absolute;
    top: 0;
    left: 0;
    height: 3vh;
    width: 3vh;
    background-color: #ffffff;
    border: 2px solid #2B2D42;
    border-radius: 32px;
  }

  .container:hover input ~ .checkmark {
    background-color: #ffffff;
    border: 2px solid #2B2D42;
  }

  .container input:checked ~ .checkmark {
    background-color: #2B2D42;
    border: 2px solid #2B2D42;
  }
  .container:hover input ~ .checkmark_desktop {
    background-color: #ffffff;
    border: 2px solid #2B2D42;
  }

  .container input:checked ~ .checkmark_desktop {
    background-color: #2B2D42;
    border: 2px solid #2B2D42;
  }

</style>
